module.exports = __webpack_public_path__ + "static/tagon-8cad88ebecc0844ba30a69e1ae0ecab3.png";